"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUnderscore = function (str) {
    return str
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
};
exports.spaceToPlus = function (str) { return str.split(/\s/).join('+'); };
//# sourceMappingURL=stringUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/wordfuzz/lib/helpers/stringUtils.js
// module id = KKF5
// module chunks = 1